<script>
import EggOrders from '@/sales/components/EggOrders.vue';

export default {
  components: {
    EggOrders,
  },
}
</script>

<template>
  <api-loader
    method="get"
    url="v1/sales/egg-orders">

    <b-card slot-scope="{result}" v-if="result" no-body>
      <egg-orders :orders="result" />
    </b-card>

  </api-loader>
</template>



// WEBPACK FOOTER //
// src/sales/views/EggOrdersView.vue